import axios from "axios";
import { first, get } from "lodash";
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as hospitalActions from "~/store/hospital/hospitalActions";
import * as notiAction from "~/store/notifications/notificationsActions";
import * as patientActions from "~/store/patient/patientAction";
import patientType from "~/store/patient/patientType";
import * as paymentTypes from "~/store/payment/paymentType";
import * as types from "~/store/totalData/types";
import {
  REDIRECT_URL_AFTER_BOOKING,
  SERVICE_TYPE_BOTH
} from "~/utils/constants";
import {
  getDataToReserve,
  getRouteFollowPartnerId,
  getStepFollowTreeMap
} from "~/utils/func";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import { handleUnAuthorize } from "~/utils/unAuthorize";

// Medicall Bill hidden

function* uploadFile({ file }) {
  try {
    const formData = new FormData();

    formData.append("File", file);

    const response = yield client.uploadFile(formData);

    console.log("response :>> ", response);

    // yield put({
    //   type: types.GET_ALL_HIDDEN_MEDICAL_BILLS_SUCCESS,
    //   payload: response.data
    // });
  } catch (error) {
    console.log(error);
    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
  }
}
function* watchUploadFile() {
  yield takeLatest(types.UPLOAD_FILE, uploadFile);
}

const nodeAction = {
  service: {
    typeSelect: types.SELECT_SERVICE,
    typeReset: types.RESET_SELECT_SERVICE,
    url: "/chon-dich-vu"
  },
  subject: {
    typeSelect: types.SELECT_SUBJECT,
    typeReset: types.RESET_SELECT_SUBJECT,
    url: "/chon-chuyen-khoa"
  },
  doctor: {
    typeSelect: types.SELECT_DOCTOR,
    typeReset: types.RESET_SELECT_DOCTOR,
    url: "/chon-bac-si"
  },
  room: {
    typeSelect: types.SELECT_ROOM,
    typeReset: types.RESET_SELECT_ROOM,
    url: "/chon-phong-kham"
  }
};

// getExtraConfig
function* requestExtraConfig() {
  try {
    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getExtraConfig({ partnerid });

    yield put({
      type: types.GET_EXTRA_CONFIG_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
  }
}

function* requestExtraConfigWatcher() {
  yield takeLatest(types.GET_EXTRA_CONFIG, requestExtraConfig);
}

// Booking Tree
function* requestBookingTree({ text, id }) {
  try {
    yield put(hospitalActions.requestHospitalList());

    const partnerid = yield select(state => state.totalData.partnerId);
    const flow = yield select(state => state.totalData.flow);

    const finalPartnerID = id || partnerid;

    axios.defaults.headers.partnerid = finalPartnerID;
    const response = yield client.getBookingTreeDynamic(
      { treeId: flow.toUpperCase() },
      {
        partnerid: finalPartnerID,
        appid: AppId
      }
    );

    yield put({
      type: types.GET_BOOKING_TREE_SUCCESS,
      payload: response.data,
      id: finalPartnerID,
      treeId: flow.toUpperCase()
    });

    const stepOne = getStepFollowTreeMap(response.data.subType, finalPartnerID);
    if (!text) {
      const firstNode = get(response, "data.child", []);
      const firstType = get(response, "data.subType");
      if (firstNode.length === 1) {
        if (
          firstType === "service" &&
          firstNode[0].detail.serviceType === "BOTH"
        ) {
          history.push(stepOne);
        } else {
          yield put({
            type: nodeAction[firstType].typeSelect,
            payload: firstNode[0]
          });
        }
      } else {
        history.push(stepOne);
      }
    }

    yield put(hospitalActions.selectHospital(finalPartnerID));
  } catch (error) {
    console.log(error);
  }
}

function* requestBookingTreeWatcher() {
  yield takeLatest(types.GET_BOOKING_TREE, requestBookingTree);
}

//  Sub Booking Tree
function* requestSubBookingTree() {
  try {
    const serviceId = yield select(state => state.totalData.service.id);
    const doctorId = yield select(state => state.totalData.doctor.id);
    const subjectId = yield select(state => state.totalData.subject.id);
    const roomId = yield select(state => state.totalData.room.id);
    const partnerid = yield select(state => state.totalData.partnerId);
    const flow = yield select(state => state.totalData.flow);

    const response = yield client.getBookingTreeCurrentNode(
      {
        treeId: flow.toUpperCase(),
        serviceId,
        doctorId,
        subjectId,
        roomId
      },
      {
        partnerid,
        appid: AppId
      }
    );
    const { type } = response.data;
    yield put({ type: types.UPDATE_CURRENT_NODE, node: response.data });
    yield put({ type: nodeAction[type].typeSelect, payload: response.data });
  } catch (error) {
    console.log(error);
  }
}

function* requestSubBookingTreeWatcher() {
  yield takeLatest(types.GET_SUB_BOOKING_TREE, requestSubBookingTree);
}

// Reserve Booking
function* requestReserveBooking() {
  try {
    const token = yield select(state => state.user.info.token);
    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);
    const partnerid = get(totalDataReducer, "partnerId");

    const platformType = get(globalReducer, "device.type");

    const postData = getDataToReserve(
      totalDataReducer,
      globalReducer,
      paymentMethodReducer,
      patientReducer,
      reExamReducer
    );
    postData.redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const response = yield client.reserveBooking(postData, {
      partnerid,
      appid: AppId,
      token,
      platform: platformType === "desktop" ? "pc" : "web"
    });

    const { data } = response;

    if (data.isGateway === 1) {
      yield put({
        type: types.RESERVE_BOOKING_SUCCESS,
        payload: data,
        AppId
      });
      window.location.href = data.qrCodeUrl;
    } else if (data.isGateway === 0) {
      if (postData.methodId === "SHARE_PAYMENT") {
        history.push(`/phieu-kham-benh/chi-tiet/${data.transactionId}`);
      } else {
        history.push(
          `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
        );

        yield put({
          type: types.GET_PAYMENT_INFO_SUCCESS,
          payload: response.data
        });
      }
    }
  } catch (error) {
    const { statusCode, message } = get(error, "response.data", "");
    openToast(message, "error");
    if (statusCode === 401) {
      handleUnAuthorize();
    }
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestReserveBookingWatcher() {
  yield takeLatest(types.RESERVE_BOOKING, requestReserveBooking);
}

function* requestBookingShareToPay({ id }) {
  try {
    const response = yield client.bookingShareToPay({ id });
    const { data } = response;

    const { paymentStatus, description } = data;

    if (paymentStatus === 2) {
      history.push("/");
      openToast(description, "error");
    }

    yield put({
      type: types.BOOKING_SHARE_TO_PAGE_SUCCESS,
      payload: { bookingInfo: data }
    });

    yield put({
      type: patientType.SELECTED_PATIENT_DETAIL,
      value: data.patient
    });

    yield put({
      type: paymentTypes.UMC_GET_ALL_PAYMENT_METHODS
    });
  } catch (error) {
    console.log("error :>> ", error);
    const errorCode = get(error, "response.data.statusCode", 0);
    const message = get(error, "response.data.message", "");
    if (errorCode) {
      history.push("/");
      openToast(message, "error");
    }
  }
}

// Repayment Booking
function* requestRepaymentBooking() {
  try {
    const totalReducer = yield select(state => state.totalData);

    const partnerid =
      totalReducer.paymentInformation?.bookingInfo?.partnerId ||
      (yield select(state => state.totalData.partnerId));

    const paymentMethodReducer = yield select(state => state.payment);

    const methodId = get(paymentMethodReducer, "methodId", "");

    const paymentTypeDetail = get(
      paymentMethodReducer,
      "selectedMethod.code",
      ""
    );

    const bookingCode = totalReducer.paymentInformation?.bookingInfo?.id;

    const status = totalReducer.paymentInformation?.bookingInfo?.status;

    const redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const postData = {
      methodId,
      paymentTypeDetail,
      redirectUrl,
      id: bookingCode
    };

    const response = yield client.rePaymentShareToPay(postData, { partnerid });

    const { data } = response;

    if (data.isGateway === 1) {
      yield put({
        type: types.RESERVE_BOOKING_SUCCESS,
        payload: data
      });

      // Đá theo qrCodeUrl đc trả về
      window.location.href = data.qrCodeUrl;
    } else if (data.isGateway === 0) {
      if (Number(status) === 6) {
        history.push(`/chi-tiet-phieu-kham-benh`);
      } else {
        history.push(
          `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
        );

        yield put({
          type: types.GET_PAYMENT_INFO_SUCCESS,
          payload: response.data
        });
      }
    }
  } catch (error) {
    const message = get(error, "response.data.message", "");
    openToast(message, "error");
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestBookingShareToPayWatcher() {
  yield takeLatest(types.BOOKING_SHARE_TO_PAGE, requestBookingShareToPay);
}

function* requestRepaymentBookingWatcher() {
  yield takeLatest(types.REPAYMENT_BOOKING, requestRepaymentBooking);
}

// Payment Info
function* requestPaymentInfo(action) {
  const transactionId = get(action, "payload", "");
  const typePaymentFormShare = yield select(
    state => state.totalData.typePayment
  );
  try {
    const partnerid = yield select(state => state.totalData.partnerId);

    const text = get(action, "text", "");
    const typePayment = get(action, "typePayment");
    const postData = {
      transactionId,
      type: typePayment
    };
    const response = yield client.getPaymentInfo(postData, { partnerid });

    const status = get(response, "data.bookingInfo.status", 0);
    const description = get(response, "data.bookingInfo.description", 0);

    if (status === 1) {
      if (text === "payment") {
        if (typePaymentFormShare === "SHARE_PAYMENT") {
          history.push("/");
        }

        openToast(`${description}`);

        yield put({
          type: types.GET_PAYMENT_INFO_SUCCESS,
          payload: response.data
        });
      }
    } else {
      history.push("/");
      throw new Error();
    }
  } catch (error) {
    console.log(error);
    const text = get(action, "text", "");
    if (text === "payment") {
      if (typePaymentFormShare === "SHARE_PAYMENT") {
        history.push("/");
      } else {
        history.push(`/phieu-kham-benh/chi-tiet/${transactionId}`);
      }
      openToast("Thanh toán không thành công!", "error");
    } else {
      history.push("/user");
      openToast("Có lỗi xảy ra, vui lòng thử lại!", "error");
    }
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
    window.localStorage.setItem("transId", JSON.stringify(transactionId));
  }
}

function* requestPaymentInfoWatch() {
  yield takeLatest(types.GET_PAYMENT_INFO, requestPaymentInfo);
}

function* requestBookingInfo(action) {
  try {
    const partnerid = yield select(state => state.totalData.partnerId);

    const transactionId = get(action, "payload", "");

    const postData = {
      transactionId
    };
    const token = yield select(state => state.user.info.token);

    const response = yield client.getBookingWithTransactionCode(postData, {
      partnerid,
      token
    });

    const patient = get(response, "data.patientInfo");

    yield put({
      type: types.GET_PAYMENT_INFO_SUCCESS,
      payload: response.data
    });

    yield put(patientActions.selectPatientFromData(patient));
  } catch (error) {
    const text = get(action, "text", "");
    if (text === "payment") {
      openToast("Thanh toán không thành công!", "error");
    } else {
      const message = get(error, "response.data.message");
      openToast(message, "error");
      history.push("/user");
    }
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
  }
}

function* watchRequestBookingInfo() {
  yield takeLatest(types.GET_BOOKING_INFO, requestBookingInfo);
}

// Medicall Bill
function* requestAllMedicalBill() {
  try {
    const token = yield select(state => state.user.info.token);
    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getAllBookingByUserId({
      partnerid,
      appid: AppId,
      token
    });
    yield put({
      type: types.GET_ALL_MEDICAL_BILLS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
    yield put({
      type: types.GET_ALL_MEDICAL_BILLS_FAILURE
    });
  }
}
function* watchRequestAllMedicalBill() {
  yield takeLatest(types.GET_ALL_MEDICAL_BILLS, requestAllMedicalBill);
}

// Medicall Bill hidden

function* requestAllHiddenMedicalBill() {
  try {
    const token = yield select(state => state.user.info.token);
    const response = yield client.getAllInvisibleBookingByUserId({
      token
    });
    yield put({
      type: types.GET_ALL_HIDDEN_MEDICAL_BILLS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
    yield put({
      type: types.GET_ALL_HIDDEN_MEDICAL_BILLS_FAILURE
    });
  }
}
function* watchRequestAllHiddenMedicalBill() {
  yield takeLatest(
    types.GET_ALL_HIDDEN_MEDICAL_BILLS,
    requestAllHiddenMedicalBill
  );
}

// auto next step
function* requestChangeStepAuto({ payload }) {
  const partnerId = yield select(state => state.totalData.partnerId);
  const serviceType = yield select(
    state => state.totalData.service.serviceType
  );
  const serviceTypeDefault = yield select(
    state => state.totalData.service.serviceTypeDefault
  );
  const {
    type,
    subType,
    child,
    detail: { nextCombine },
    dynamic,
    pickType
  } = payload;

  if (pickType) {
    yield put({ type: types.SET_SCHEDULE_WITHOUT_DATE, payload: true });
    yield put({ type: types.ADD_SCHEDULE });
    history.push("/chon-ho-so");
  } else if (dynamic) {
    yield put({ type: types.GET_SUB_BOOKING_TREE });
  } else {
    const nextRoute = getStepFollowTreeMap(subType, partnerId);
    if (child.length === 1) {
      const checkBH =
        serviceTypeDefault !== SERVICE_TYPE_BOTH ||
        (serviceTypeDefault === SERVICE_TYPE_BOTH && serviceType !== "");
      if (checkBH) {
        yield put({ type: nodeAction[subType].typeSelect, payload: child[0] });
      } else if (
        first(child).detail.serviceType === SERVICE_TYPE_BOTH &&
        partnerId === "umc"
      ) {
        history.push(nextRoute);
      }
    } else {
      if (type === "service") {
        // step chọn dịch vụ, kiểm tra type Bảo hiểm
        if (
          serviceTypeDefault !== SERVICE_TYPE_BOTH ||
          (serviceTypeDefault === SERVICE_TYPE_BOTH && serviceType !== "")
        ) {
          history.push(nextRoute);
        }
      } else if (type === "doctor") {
        // step chọn bác sĩ, kiểm tra nextCombine
        if (!nextCombine) {
          history.push(nextRoute);
        }
      } else {
        history.push(nextRoute);
      }
    }
  }
}

function* watchRequestChangeStepAuto() {
  yield takeLatest(types.SELECT_SUBJECT, requestChangeStepAuto);
  yield takeLatest(types.SELECT_SERVICE, requestChangeStepAuto);
  yield takeLatest(types.SELECT_DOCTOR, requestChangeStepAuto);
  yield takeLatest(types.SELECT_ROOM, requestChangeStepAuto);
}

// back action
function* requestGoBack({ node }) {
  const partnerId = yield select(state => state.totalData.partnerId);
  const listNode = yield select(state => state.totalData.listNode);
  const index = listNode.findIndex(item => item === node);
  const serviceTypeDefault = yield select(
    state => state.totalData.service.serviceTypeDefault
  );

  /**
   * index === 0 --> node đầu tiên --> kiểm tra AppId -->
   *     medpro || momo --> kiểm tra list feature
   *           length = 1  --> chọn bệnh viện
   *           length > 1  --> chọn feature
   *     bệnh viện  --> home
   * index > 0 --> kiểm tra list parent
   *     length = 1  --> gọi lại function này
   *     length > 1  --> redirect về node cha
   */
  if (index === 0) {
    if (AppId === "medpro" || AppId === "momo") {
      const listFeature = yield select(
        state => state.features.allFeatures.list
      );
      if (listFeature.length === 1) {
        history.push("/chon-benh-vien");
      } else {
        const url = getRouteFollowPartnerId(
          "/chon-hinh-thuc-dat-kham",
          partnerId
        );
        history.push(url);
      }
    } else {
      history.push("/");
    }
  } else {
    const parentName =
      index === -1 ? listNode[listNode.length - 1] : listNode[index - 1];

    const parentNode = yield select(state => state.totalData[parentName]);

    const url = getStepFollowTreeMap(parentNode.type, partnerId);
    if (parentNode.list.length > 1) {
      history.push(url);
    } else {
      if (parentNode.type === "service") {
        if (serviceTypeDefault === SERVICE_TYPE_BOTH) {
          history.push(url);
        } else {
          yield put({ type: types.GO_BACK_STEP, node: parentName });
        }
      } else {
        yield put({ type: types.GO_BACK_STEP, node: parentName });
      }
    }
  }
}

function* watchRequestGoBack() {
  yield takeLatest(types.GO_BACK_STEP, requestGoBack);
}

// reset list node
function* resetListNode({ payload }) {
  /**
   * So sánh node với list node
   * Reset toàn bộ các node phía sau
   * Reset ngày tháng: case chọn BH --> tôi không có BH
   */

  // Reset ngày giờ
  yield put({ type: types.RESET_SELECT_DATE });
  yield put({ type: types.RESET_SELECT_TIME_SLOT });

  let listNode = yield select(state => state.totalData.listNode);
  const index = listNode.findIndex(item => item === payload);
  if (index === 0) {
    // reset all
    for (const item of Object.keys(nodeAction)) {
      yield put({ type: nodeAction[item].typeReset });
    }
  } else {
    listNode = listNode.slice(listNode.findIndex(item => item === payload));
    for (const item of listNode) {
      yield put({ type: nodeAction[item].typeReset });
    }
  }
}

function* watchResetListNode() {
  yield takeLatest(types.RESET_LIST_NODE, resetListNode);
}

// Đặt khám theo partner momo
function* requestReserveBookingPartner() {
  try {
    // danh sách hình thức thanh toán
    yield put({
      type: paymentTypes.UMC_GET_ALL_PAYMENT_METHODS
    });
  } catch (error) { }
}

function* watchReserveBookingPartner() {
  yield takeLatest(types.RESERVE_PAYMENT_PARTNER, requestReserveBookingPartner);
}

export default function* root() {
  yield all([
    fork(watchUploadFile),
    fork(requestExtraConfigWatcher),
    fork(watchRequestAllHiddenMedicalBill),
    fork(requestBookingTreeWatcher),
    fork(requestReserveBookingWatcher),
    fork(requestBookingShareToPayWatcher),
    fork(requestRepaymentBookingWatcher),
    fork(requestPaymentInfoWatch),
    fork(watchRequestBookingInfo),
    fork(watchRequestAllMedicalBill),
    fork(watchRequestChangeStepAuto),
    fork(requestSubBookingTreeWatcher),
    fork(watchResetListNode),
    fork(watchReserveBookingPartner),
    fork(watchRequestGoBack)
  ]);
}
